import { useQueryClient as l, useMutation as y, useQuery as m } from "@tanstack/react-query";
import t from "./user-projects.api.js";
import { teachurKeys as n } from "../../constants/teachurKeys.js";
const S = (e, s) => m({
  queryKey: n.userProjects.list(e),
  queryFn: async () => (await t.getAll(e)).data,
  ...s
}), i = (e) => {
  const s = l();
  return y({
    mutationFn: async ({ projectId: r, file: u }) => (await t.create(r, u)).data,
    onSuccess: (r, u, c) => {
      var a;
      s.invalidateQueries({ queryKey: n.userProjects.all }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, c);
    },
    ...e
  });
}, d = (e) => {
  const s = l();
  return y({
    mutationFn: async ({ id: r, instructorId: u }) => (await t.claim(r, u)).data,
    onSuccess: (r, u, c) => {
      var a;
      s.invalidateQueries({ queryKey: n.userProjects.all }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, c);
    },
    ...e
  });
}, v = (e) => {
  const s = l();
  return y({
    mutationFn: async (r) => (await t.disclaim(r)).data,
    onSuccess: (r, u, c) => {
      var a;
      s.invalidateQueries({ queryKey: n.userProjects.all }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, c);
    },
    ...e
  });
}, w = (e) => {
  const s = l();
  return y({
    mutationFn: async (r) => (await t.remove(r)).data,
    onSuccess: (r, u, c) => {
      var a;
      s.invalidateQueries({ queryKey: n.userProjects.all }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, c);
    },
    ...e
  });
}, Q = (e) => {
  const s = l();
  return y({
    mutationFn: async ({ userProjectId: r, submissionId: u }) => (await t.removeSubmission(r, u)).data,
    onSuccess: (r, u, c) => {
      var a;
      s.invalidateQueries({ queryKey: n.userProjects.all }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, c);
    },
    ...e
  });
}, C = (e, s, r) => m({
  queryKey: n.userProjects.submissions(e, s),
  queryFn: async () => !e || !s ? null : (await t.getAllForProject(e, s)).data,
  enabled: !!e && !!s,
  ...r
}), F = (e) => {
  const s = l();
  return y({
    ...e,
    mutationFn: async ({ id: r, ...u }) => (await t.review(r, u)).data,
    onSuccess: (r, u, c) => {
      var a;
      s.invalidateQueries({
        queryKey: n.userProjects.all
      }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, c);
    }
  });
};
export {
  d as useClaimUserProjectMutation,
  i as useCreateUserProjectMutation,
  w as useDeleteUserProjectMutation,
  Q as useDeleteUserProjectSubmissionMutation,
  v as useDisclaimUserProjectMutation,
  C as useGetProjectSubmissionsQuery,
  S as useGetUserProjectsQuery,
  F as useReviewUserProjectMutation
};
